export const HIDE_MESSAGES = ['AUTH_MISSING_AUTHORIZATION_HEADER'];
